import { render, staticRenderFns } from "./ReportingTable.vue?vue&type=template&id=99dcfda2&"
import script from "./ReportingTable.vue?vue&type=script&lang=js&"
export * from "./ReportingTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports